import { api } from "..";
const endpoint = "/api/inventory/devolutions";

export const getDevolutionList = async (queryParams) => {
  return await api.get(`${endpoint}`, { params: queryParams });
};

export const getDevolutionById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createDevolution = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateDevolution = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteDevolution = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
}; 